var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-button',{staticClass:"send-btn-c",attrs:{"disabled":_vm.disable,"loading":_vm.load,"hairline":"","loading-text":"发送中...","native-type":"button","plain":"","type":"danger"},on:{"click":_vm.send}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }